import React from 'react';
import { Card, Button, Table, Tag } from 'antd';
import { ReplenishmentRecommendation } from '../../../../services/supplyChainService';

interface ReplenishmentTableProps {
    data: ReplenishmentRecommendation[];
    loading: boolean;
    selectedRowKeys: React.Key[];
    onSelectionChange: (keys: React.Key[]) => void;
    onGeneratePO: () => void;
}

export const ReplenishmentTable: React.FC<ReplenishmentTableProps> = ({
    data, loading, selectedRowKeys, onSelectionChange, onGeneratePO
}) => {
    const columns = [
        {
            title: '图片', dataIndex: 'main_image', key: 'main_image',
            render: (src: string) => src ? <img src={src} alt="product" style={{ width: 40, height: 40, objectFit: 'cover' }} /> : '-'
        },
        {
            title: 'SKU / 名称', key: 'sku',
            render: (text: any, record: ReplenishmentRecommendation) => (
                <div>
                    <div style={{ fontWeight: 'bold' }}>{record.sku_code}</div>
                    <div style={{ fontSize: '12px', color: '#888' }}>{record.product_name}</div>
                </div>
            )
        },
        { title: '现有库存', dataIndex: 'total_stock', key: 'total_stock', sorter: (a: any, b: any) => a.total_stock - b.total_stock },
        { title: '日均销量', dataIndex: 'avg_daily_sales', key: 'avg_daily_sales', sorter: (a: any, b: any) => a.avg_daily_sales - b.avg_daily_sales },
        {
            title: '库存周转天数', dataIndex: 'cover_days', key: 'cover_days',
            render: (val: number) => (
                <Tag color={val < 30 ? 'red' : val > 120 ? 'orange' : 'green'}>{val}</Tag> // Simplified thresholds for display
            ),
            sorter: (a: any, b: any) => a.cover_days - b.cover_days
        },
        {
            title: '建议补货量', dataIndex: 'restock_needed', key: 'restock_needed',
            render: (val: number) => <span style={{ color: val > 0 ? 'red' : 'inherit', fontWeight: val > 0 ? 'bold' : 'normal' }}>{val}</span>,
            sorter: (a: any, b: any) => a.restock_needed - b.restock_needed
        },
        {
            title: '状态', dataIndex: 'status', key: 'status',
            render: (status: string) => {
                let color = 'default';
                if (status === '缺货预警') color = 'red';
                if (status === '冗余风险') color = 'orange';
                if (status === '正常') color = 'green';
                return <Tag color={color}>{status}</Tag>;
            },
            filters: [
                { text: '缺货预警', value: '缺货预警' },
                { text: '冗余风险', value: '冗余风险' },
                { text: '正常', value: '正常' },
            ],
            onFilter: (value: any, record: any) => record.status === value,
        }
    ];

    return (
        <Card title="补货建议列表 (Replenishment Advice)" extra={
            <Button type="primary" onClick={onGeneratePO} disabled={selectedRowKeys.length === 0}>
                生成采购单
            </Button>
        }>
            <Table
                columns={columns}
                dataSource={data}
                rowKey="sku_code"
                loading={loading}
                pagination={{ pageSize: 20 }}
                rowSelection={{ selectedRowKeys, onChange: onSelectionChange }}
            />
        </Card>
    );
};
